import React from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContextProvider";

const PrivateRoute = ({ children }) => {
  const { token } = React.useContext(AuthContext);
// let token = JSON.parse(localStorage.getItem("token")) || null;

  // console.log(token)
  if (token) {
    return children;
  } else {
    alert("To see recipes you need to login First")
    return <Navigate to="/login" />;
  }
};


export default PrivateRoute;
